import React from "react";
import BaseChart from "./BaseChart";
import ChartCommonConfig from "./ChartCommonConfig";

const BookingChart = (props) => {
  const isBarorSpline = ["bar", "spline"].includes(props.type);
  const isPie = props.type === "pie";
  const isDonut = props.type === "donut";
  return (
    <BaseChart
      {...(isBarorSpline && ChartCommonConfig)}
      {...(isPie && {
        color: ChartCommonConfig.color,
      })}
      {...(isDonut && {
        color: {
          pattern: ["#40abfd", "#01e397"],
        },
      })}
      data={{
        ...props.data,
        type: props.type,
        groups:
          props.type === "bar" && props.isStacked
            ? [
                (() => {
                  if (props.data.json.length > 0) {
                    return Object.keys(props.data.json[0]).filter((key) => key !== "date");
                  } else return [];
                })(),
              ]
            : [],
      }}
      {...(isDonut && {
        donut: {
          title: "Carbonate savings",
        },
      })}
      legend={{ hide: props.hideLegend }}
    ></BaseChart>
  );
};

export default BookingChart;
